import React from 'react';
import { US_STATES, COUNTRIES, citiesForState } from '../../data/geo';

// Reusable Country / State / City inputs backed by the shared geo data.
// State & Country are proper dropdowns; City is a free-text input with a
// <datalist> of suggestions (filtered by the chosen state) so any value is valid.

const baseCls =
  'w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-primary-500 focus:border-transparent';

export function StateSelect({ value, onChange, name = 'state', disabled = false, className = '', includeBlank = true, error = false }) {
  return (
    <select
      name={name}
      value={value || ''}
      onChange={onChange}
      disabled={disabled}
      className={`${baseCls} ${error ? 'border-red-300' : 'border-gray-300'} ${disabled ? 'bg-gray-50' : ''} ${className}`}
    >
      {includeBlank && <option value="">Select state…</option>}
      {US_STATES.map((s) => (
        <option key={s.code} value={s.code}>{s.code} — {s.name}</option>
      ))}
    </select>
  );
}

export function CountrySelect({ value, onChange, name = 'country', disabled = false, className = '', error = false }) {
  return (
    <select
      name={name}
      value={value || 'USA'}
      onChange={onChange}
      disabled={disabled}
      className={`${baseCls} ${error ? 'border-red-300' : 'border-gray-300'} ${disabled ? 'bg-gray-50' : ''} ${className}`}
    >
      {COUNTRIES.map((c) => (
        <option key={c} value={c}>{c}</option>
      ))}
    </select>
  );
}

let cityListSeq = 0;
export function CityInput({ value, onChange, name = 'city', state, disabled = false, className = '', placeholder = 'City', error = false }) {
  // Unique datalist id so multiple CityInputs on one page don't collide.
  const listId = React.useMemo(() => `city-suggestions-${++cityListSeq}`, []);
  const suggestions = React.useMemo(() => citiesForState(state), [state]);
  return (
    <>
      <input
        type="text"
        name={name}
        value={value || ''}
        onChange={onChange}
        disabled={disabled}
        list={listId}
        autoComplete="off"
        placeholder={placeholder}
        className={`${baseCls} ${error ? 'border-red-300' : 'border-gray-300'} ${disabled ? 'bg-gray-50' : ''} ${className}`}
      />
      <datalist id={listId}>
        {suggestions.map((c) => (
          <option key={c} value={c} />
        ))}
      </datalist>
    </>
  );
}
